import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./givex_api_server.js";
//#region src/givex_api_server_helper.ts
var givex_api_server_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(apiServer) {
	switch (apiServer) {
		case 1: return "Sandbox";
		case 2: return "Beta";
		case 3: return "Production (dc-us2/dc-us1)";
		case 4: return "Production (dc-ca2/dc-ca1)";
		case 5: return "Production (dc-pt1/dc-pt2)";
	}
}
//#endregion
export { givex_api_server_helper_exports, name };

//# sourceMappingURL=givex_api_server_helper.js.map